import { render, staticRenderFns } from "./FSNsDetailed.vue?vue&type=template&id=87eca542&scoped=true"
import script from "./FSNsDetailed.vue?vue&type=script&lang=js"
export * from "./FSNsDetailed.vue?vue&type=script&lang=js"
import style0 from "./FSNsDetailed.vue?vue&type=style&index=0&id=87eca542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eca542",
  null
  
)

export default component.exports